/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";

@Component({
  selector: "app-collect-chargeback-modal",
  templateUrl: "./collect-chargeback-modal.component.html"
})
export class CollectChargebackModalComponent implements OnInit {
  @Input() chargeback!: any;
  actionInProgress = false;
  onClose!: Subject<boolean>;

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  submit(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
